import { newAPI } from '../../../services';

export const fetchComissionedPayrollListSettings = async (userId, establishmentId, page, limit, qp) => {
  const url = establishmentId
    ? `${userId}/establishment/${establishmentId}/commissionedsettings?pg=${page}&limit=${limit}${qp}`
    : `${userId}/commissionedsettings?pg=${page}&limit=${limit}${qp}`;

  const response = await newAPI.get(url);
  return response.data;
}

export const fetchComissionedListFull = async (userId, establishmentId) => {
  const response = await newAPI.get(`${userId}/establishment/${establishmentId}/commissionedsettings/list_full`);
  return response.data;
}